import { render } from "./KpiCardAlternative.vue?vue&type=template&id=6ddf1004&scoped=true"
import script from "./KpiCardAlternative.vue?vue&type=script&lang=js"
export * from "./KpiCardAlternative.vue?vue&type=script&lang=js"

import "./KpiCardAlternative.vue?vue&type=style&index=0&id=6ddf1004&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6ddf1004"]])

export default __exports__